import { Component } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { LanguageProvider } from "@/context/LanguageContext";
import LandingPage from "@/components/LandingPage";
import AdminPage from "@/components/AdminPage";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { err: false };
    }
    static getDerivedStateFromError() {
        return { err: true };
    }
    render() {
        if (this.state.err) {
            return (
                <div className="grid min-h-screen place-items-center bg-ink text-brass">
                    <p className="font-display text-2xl">عذراً، حدث خطأ غير متوقع</p>
                </div>
            );
        }
        return this.props.children;
    }
}

export default function App() {
    return (
        <ErrorBoundary>
            <LanguageProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<LandingPage />} />
                        <Route path="/admin" element={<AdminPage />} />
                        <Route path="*" element={<LandingPage />} />
                    </Routes>
                    <Toaster theme="dark" position="top-center" />
                </BrowserRouter>
            </LanguageProvider>
        </ErrorBoundary>
    );
}
